// table 数据相关
import request from '@/api/request'

/*  
    serverUrl : 基础的 api 地址
    datas : data id
*/
export function locationApi(serverUrl: string | undefined, params?:object) {
    let url = serverUrl + "/location/init";

    if(params == null){
        params = {
            "default": 1
        }
    }

    return request({
        url: url,
        method: 'post',
        params
    })
}

/*  
    serverUrl : 基础的 api 地址
    datas : data id
*/
export function exchangeApi(serverUrl: string | undefined, oldindex: number,newindex: number) {
    let url = serverUrl + "/location/exchange";

    let data = {
        "oldindex" : oldindex,
        "newindex" : newindex
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}